import { ApplicationPhaseFragment, AtsHiringStageNamesEnum } from 'generated/resources/graphql'
import { sortBy } from 'lodash'

import { AtsHiringStageNames } from 'modules/ats/lib/utils/hiringStages'

export interface StageWithPhases {
  id: string
  position: number
  name: AtsHiringStageNames
  phases: ApplicationPhaseFragment[]
}

export const isHiredStage = (hiringStageName: AtsHiringStageNamesEnum | undefined) => {
  return hiringStageName === 'hired'
}

export const isOfferStage = (hiringStageName: AtsHiringStageNamesEnum | undefined) => {
  return hiringStageName === 'offer'
}

export const isAssessmentStage = (hiringStageName: AtsHiringStageNamesEnum | undefined) => {
  return hiringStageName === 'assessment'
}

export const sortApplicationPhases = (applicationPhases: ApplicationPhaseFragment[]) => {
  return sortBy(
    applicationPhases,
    [
      function (phase) {
        return phase.hiringStage ? phase.hiringStage.position : -2
      },
      function (phase) {
        return phase.position
      },
    ],
    ['asc', 'asc']
  )
}

export const getEditableApplicationPhases = (phases: ApplicationPhaseFragment[]) => {
  return phases.filter((phase) => phase.phaseType != 'initial' && phase.phaseType != 'hired')
}
